import React from 'react'
import { CartProductBlock, CartProductPrice, CartProductTitle, CartProductTotalPriceBlock, CartProductWrapper } from '../index.styled'
import { encryptGiftCode } from '../../../../../../helper/encryptGiftCode'
import { useTranslation } from 'react-i18next'
import Currency from '../../../../../Elements/currency'
import { CLIENT_MONITOR_COUPON_TYPES } from '../../../../../../redux/selector/cart/constants'

const CartCoupon = React.memo(({ coupon, isPayment = false }) => {
	const { t } = useTranslation()
	const isCoupon = CLIENT_MONITOR_COUPON_TYPES.includes(coupon?.type)
	const isGiftCoupon = coupon?.type === 'GIFT_COUPON'
	const code = encryptGiftCode(coupon?.couponMetaData?.code)
	const couponName = isCoupon ?
		(t('Cart.coupon') + ' ' + coupon.name) :
		(t('Cart.gift_coupon') + ' ' + code)
	const couponLayout = ((isPayment || isCoupon) ? 'coupon-payment' : 'coupon-item')

	return (
		<CartProductWrapper>
			<CartProductBlock>
				<CartProductTitle className={couponLayout}>{couponName}</CartProductTitle>
				{!isPayment && isGiftCoupon &&
					<CartProductTotalPriceBlock>
						<CartProductPrice data-testid="coupon-price" className="total"><Currency>{coupon?.price}</Currency></CartProductPrice>
					</CartProductTotalPriceBlock>}
			</CartProductBlock>
		</CartProductWrapper>
	)
})

CartCoupon.displayName = 'CartCoupon'
export default CartCoupon
